<template>
  <div>
    <v-card>
      <v-card-title>
        All Donations
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-btn
          small
          style='margin-top : 15px; margin-right : 15px'
          @click='downloadCSV'
        >Download CSV</v-btn>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-model='selected'
        show-select
        :headers="headers"
        :items="assets"
        :search="search"
      >
        <template v-slot:item.Value="{ item }">
          ${{item.Value}}
        </template>
        <template v-slot:item.receivedDate="{ item }">
          {{item.receivedDate}} {{dayElapsed(item.receivedDate)}}
        </template>
        <template v-slot:item.tracking="{item }">
          <a
            :href='`https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${item.tracking}&requester=ST/trackdetails`'
            target='blank'
          >{{item.tracking}}</a>
        </template>
        <template v-slot:item.donor="{ item }">
          {{lookupName(item.donor)}}
        </template>

        <template v-slot:item.id="{item }">
          <a
            style='text-decoration: underline;'
            @click='goTo(item)'
          >{{item.id}}</a>
        </template>
      </v-data-table>
    </v-card>

  </div>
</template>

<script>
import papa from "papaparse";
import moment from "moment";
const fb = require("../../firebaseconfig");
export default {
  data() {
    return {
      donors: [],
      dialog: false,
      selected: [],
      headers: [
        { text: "Status", value: "status" },
        { text: "Donation ID", value: "id" },
        { text: "Date Received", value: "receivedDate", filterable: true },
        { text: "Total Value", value: "Value" },
        { text: "# of Assets", value: "computerToDonate" },
        { text: "Description", value: "description" },
        { text: "Donor", value: "donor" },
        { text: "Tracking", value: "tracking" },
      ],
      search: null,
      donations: null,
      ngo: [],
      assets: [],
    };
  },
  async mounted() {
    fb.auth.currentUser.getIdTokenResult().then(async (idTokenResult) => {
      await this.getDonors(idTokenResult.claims);
      await this.getDonations(idTokenResult.claims);
    });
  },
  methods: {
    lookupName(donorID) {
      let name = this.donors.find((d) => d.id === donorID);
      return name ? name.name : "";
    },
    downloadCSV() {
      let csv = papa.unparse(this.assets);
      var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, "download.csv");
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", "download.csv");
      tempLink.click();
    },
    goTo(item) {
      this.$router.push("/donations/" + item.id);
    },
    dayElapsed(time) {
      if (time) {
        return "(" + moment().diff(time, "days") + "days old)";
      } else {
        return "Not yet received";
      }
    },
    async getDonors(claims) {
      await fb.db
        .collection("donors")
        .where("ngo", "==", claims.npo)
        .where("ngo", "==", claims.npo)
        .onSnapshot((query) => {
          this.donors = [];
          query.forEach((ngo) => {
            this.donors.push(ngo.data());
          });
        });
    },
    async getDonations(claims) {
      await fb.db
        .collection("donations")
        .where("ngo", "==", claims.npo)
        .onSnapshot((query) => {
          this.assets = [];
          query.forEach((ngo) => {
            this.assets.push(ngo.data());
          });
        });
    },
  },
};
</script>